import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ConversationStatus } from 'src/app/samwebDescription/samwin/ConversationStatus';

@Component({
   selector: 'samweb-call-time',
   templateUrl: './call-time.component.html',
   styleUrls: ['./call-time.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallTimeComponent implements OnInit {
   constructor() {
      this.ShowPrimaryFullDateFormat = false;
      this.ConversationStatus = ConversationStatus.UNKNOWN;
   }
   public CallTimestamp: any;
   public ShowPrimaryFullDateFormat: boolean;
   public ConversationStatus: ConversationStatus;

   @Input()
   set timestamp(ts: any) {
      this.CallTimestamp = ts;
   }

   @Input()
   set showPrimaryFullDateFormat(showFullDate: boolean) {
      this.ShowPrimaryFullDateFormat = showFullDate;
   }

   @Input()
   set conversationStatusTypeAsSamwinValue(samwinValue: number) {
      this.ConversationStatus = ConversationStatus.valueBySamwinValue(samwinValue);
   }

   ngOnInit() {}
}
